const feedRecordsUtils = {
    isWitchMonth: (monthAge) => { // 封装根据宝宝月龄判断吃几段奶粉
        if (0 <= monthAge && monthAge <= 5) {
            return 'S01'
        } else if (6 <= monthAge && monthAge <= 11) {
            return 'S02'
        } else if (12 <= monthAge && monthAge <= 36) {
            return 'S03'
        }
    },
    KCTotal(MDStage, kcTabs) { // 判断是哪一段位来断定是多少库存种类
        for (let i = 0; i < kcTabs.length; i++) {
            if (MDStage == ('S03' || '三段')) {
                return kcTabs[1].total
            } else if (MDStage == ('S02' || '二段')) {
                return kcTabs[2].total
            } else if (MDStage == ('S01' || '一段')) {
                return kcTabs[3].total
            } else if (MDStage == '全部') {
                return kcTabs[0].total
            }
        }
    }
}
export default feedRecordsUtils;